import React from 'react';

import { ExperienceSuccess as AkExperienceSuccess } from '@atlassian/experience-tracker';

import { type UserExperienceNames } from './utils';

interface Props {
	// Make sure data is loaded before rendering <AkExperienceSuccess />
	hasLoaded: boolean;
	name: UserExperienceNames;
	attributes?: Record<string, string>;
}

export function ExperienceSuccess(props: Props) {
	const { hasLoaded, name, attributes } = props;

	if (!hasLoaded) {
		return null;
	}

	return <AkExperienceSuccess name={name} attributes={attributes} />;
}
